export const ADMIN_ROLE = 'admin';
export const EDITOR_ROLE = 'editor';
// An admin who can also reveal masked personal data (PII) in traces and conversations.
export const SECURITY_ADMIN_ROLE = 'security_admin';
